export default "__VITE_ASSET__DRbmpQ3P__"